module.exports = __webpack_public_path__ + "img/instagram-logo.d7ccd0f8.svg";